import React from 'react';
import { useNavigate } from 'react-router-dom';

function Buttonn() {
  const navigate = useNavigate();

  const handleBookNowClick = () => {
    // Redirect to the /book-taxi page
    navigate('/book-taxi');
  };

  return (
    <div>
      <button className='buttonn' onClick={handleBookNowClick}>Book Now</button>
    </div>
  );
}

export default Buttonn;
